import React from 'react';
import Slider from 'react-slick';
import TrustBox from '../../Components/Shared/TrustBox';

type Props = {};

const ReviewSlider = (props: Props) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3
    };
    const mobileSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1, // Show 1 item on mobile
        slidesToScroll: 1,
    };

    return (
        <section className="peoplesaying_section">
            <div className="container">
                <div className="peoplesaying">
                    <div className="peoplesaying_heding">
                        <h4>What People are Saying</h4>
                    </div>
                    <div className="row slider_container">
                        <div className="col-md-3 review-widget trustpilot-tn">
                            <TrustBox/>
                        </div>
                        <div className="col-md-9">
                            <div className="swiper-container review-section">
                                <Slider {...settings} responsive={[
                                    {
                                        breakpoint: 768,
                                        settings: mobileSettings,
                                    },]} className="slick-slider " >
                                    <div className='slick_item'>
                                        <div className='d-flex tp-stars--5 w-50 mr-2'>
                                            <svg viewBox="0 0 251 46" xmlns="http://www.w3.org/2000/svg">
                                                <g className="tp-star">
                                                    <path className="tp-star__canvas" fill="#dcdce6" d="M0 46.330002h46.375586V0H0z"></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M51.24816 46.330002h46.375587V0H51.248161z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M51.24816 46.330002h23.187793V0H51.248161z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M74.990978 31.32991L81.150908 30 84 39l-9.660206-7.202786L64.30279 39l3.895636-11.840666L58 19.841466h12.605577L74.499595 8l3.895637 11.841466H91L74.990978 31.329909z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M102.532209 46.330002h46.375586V0h-46.375586z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M102.532209 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M142.066994 19.711433L115.763298 38.80065l3.838215-11.797827-10.047304-7.291391h12.418975l3.837418-11.798624 3.837417 11.798624h12.418975zM125.81156 31.510075l7.183595-1.509576 2.862113 8.800152-10.045708-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M153.815458 46.330002h46.375586V0h-46.375586z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M153.815458 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M193.348355 19.711433L167.045457 38.80065l3.837417-11.797827-10.047303-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418974zM177.09292 31.510075l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M205.064416 46.330002h46.375587V0h-46.375587z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M205.064416 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M244.597022 19.711433l-26.3029 19.089218 3.837419-11.797827-10.047304-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418975zm-16.255436 11.798642l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                            </svg>
                                        </div>
                                        <b className="review-header">Fantastic and easy platform!!</b>
                                        <div className="review-text">It fixed damaged or poorly coded pdf form and converted it to a form in Word where I can fill it out.</div>
                                        <div className="review-name">Nicklaus</div>
                                        <div className="review-date">3 hours ago</div>
                                    </div>
                                    <div className='slick_item'>
                                        <div className='d-flex tp-stars--5 w-50'>
                                            <svg viewBox="0 0 251 46" xmlns="http://www.w3.org/2000/svg">
                                                <g className="tp-star">
                                                    <path className="tp-star__canvas" fill="#dcdce6" d="M0 46.330002h46.375586V0H0z"></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M51.24816 46.330002h46.375587V0H51.248161z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M51.24816 46.330002h23.187793V0H51.248161z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M74.990978 31.32991L81.150908 30 84 39l-9.660206-7.202786L64.30279 39l3.895636-11.840666L58 19.841466h12.605577L74.499595 8l3.895637 11.841466H91L74.990978 31.329909z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M102.532209 46.330002h46.375586V0h-46.375586z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M102.532209 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M142.066994 19.711433L115.763298 38.80065l3.838215-11.797827-10.047304-7.291391h12.418975l3.837418-11.798624 3.837417 11.798624h12.418975zM125.81156 31.510075l7.183595-1.509576 2.862113 8.800152-10.045708-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M153.815458 46.330002h46.375586V0h-46.375586z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M153.815458 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M193.348355 19.711433L167.045457 38.80065l3.837417-11.797827-10.047303-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418974zM177.09292 31.510075l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M205.064416 46.330002h46.375587V0h-46.375587z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M205.064416 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M244.597022 19.711433l-26.3029 19.089218 3.837419-11.797827-10.047304-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418975zm-16.255436 11.798642l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                            </svg>
                                        </div>
                                        <b className="review-header">Quick and easy</b>
                                        <div className="review-text">Awesome! User friendly would recommend to anyone</div>
                                        <div className="review-name">Nicklaus</div>
                                        <div className="review-date">3 hours ago</div>
                                    </div> <div className='slick_item'>
                                        <div className='d-flex tp-stars--5 w-50'>
                                            <svg viewBox="0 0 251 46" xmlns="http://www.w3.org/2000/svg">
                                                <g className="tp-star">
                                                    <path className="tp-star__canvas" fill="#dcdce6" d="M0 46.330002h46.375586V0H0z"></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M51.24816 46.330002h46.375587V0H51.248161z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M51.24816 46.330002h23.187793V0H51.248161z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M74.990978 31.32991L81.150908 30 84 39l-9.660206-7.202786L64.30279 39l3.895636-11.840666L58 19.841466h12.605577L74.499595 8l3.895637 11.841466H91L74.990978 31.329909z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M102.532209 46.330002h46.375586V0h-46.375586z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M102.532209 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M142.066994 19.711433L115.763298 38.80065l3.838215-11.797827-10.047304-7.291391h12.418975l3.837418-11.798624 3.837417 11.798624h12.418975zM125.81156 31.510075l7.183595-1.509576 2.862113 8.800152-10.045708-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M153.815458 46.330002h46.375586V0h-46.375586z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M153.815458 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M193.348355 19.711433L167.045457 38.80065l3.837417-11.797827-10.047303-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418974zM177.09292 31.510075l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M205.064416 46.330002h46.375587V0h-46.375587z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M205.064416 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M244.597022 19.711433l-26.3029 19.089218 3.837419-11.797827-10.047304-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418975zm-16.255436 11.798642l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                            </svg>
                                        </div>

                                        <b className="review-header">Love it!</b>
                                        <div className="review-text">Great! A+ experience. Would definitely recommend to others.</div>
                                        <div className="review-name">Nicklaus</div>
                                        <div className="review-date">1 day ago</div>
                                    </div> <div className='slick_item'>
                                        <div className='d-flex tp-stars--5 w-50'>
                                            <svg viewBox="0 0 251 46" xmlns="http://www.w3.org/2000/svg">
                                                <g className="tp-star">
                                                    <path className="tp-star__canvas" fill="#dcdce6" d="M0 46.330002h46.375586V0H0z"></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M51.24816 46.330002h46.375587V0H51.248161z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M51.24816 46.330002h23.187793V0H51.248161z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M74.990978 31.32991L81.150908 30 84 39l-9.660206-7.202786L64.30279 39l3.895636-11.840666L58 19.841466h12.605577L74.499595 8l3.895637 11.841466H91L74.990978 31.329909z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M102.532209 46.330002h46.375586V0h-46.375586z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M102.532209 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M142.066994 19.711433L115.763298 38.80065l3.838215-11.797827-10.047304-7.291391h12.418975l3.837418-11.798624 3.837417 11.798624h12.418975zM125.81156 31.510075l7.183595-1.509576 2.862113 8.800152-10.045708-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M153.815458 46.330002h46.375586V0h-46.375586z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M153.815458 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M193.348355 19.711433L167.045457 38.80065l3.837417-11.797827-10.047303-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418974zM177.09292 31.510075l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M205.064416 46.330002h46.375587V0h-46.375587z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M205.064416 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M244.597022 19.711433l-26.3029 19.089218 3.837419-11.797827-10.047304-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418975zm-16.255436 11.798642l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                            </svg>
                                        </div>
                                        <b className="review-header">Easy to use</b>
                                        <div className="review-text">Worked perfectly, and fast! Super easy too, I just needed to drag and drop and click a single button!</div>
                                        <div className="review-name">Pamela</div>
                                        <div className="review-date">3 days ago</div>
                                    </div> <div className='slick_item'>
                                        <div className='d-flex tp-stars--5 w-50'>
                                            <svg viewBox="0 0 251 46" xmlns="http://www.w3.org/2000/svg">
                                                <g className="tp-star">
                                                    <path className="tp-star__canvas" fill="#dcdce6" d="M0 46.330002h46.375586V0H0z"></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M51.24816 46.330002h46.375587V0H51.248161z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M51.24816 46.330002h23.187793V0H51.248161z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M74.990978 31.32991L81.150908 30 84 39l-9.660206-7.202786L64.30279 39l3.895636-11.840666L58 19.841466h12.605577L74.499595 8l3.895637 11.841466H91L74.990978 31.329909z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M102.532209 46.330002h46.375586V0h-46.375586z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M102.532209 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M142.066994 19.711433L115.763298 38.80065l3.838215-11.797827-10.047304-7.291391h12.418975l3.837418-11.798624 3.837417 11.798624h12.418975zM125.81156 31.510075l7.183595-1.509576 2.862113 8.800152-10.045708-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M153.815458 46.330002h46.375586V0h-46.375586z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M153.815458 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M193.348355 19.711433L167.045457 38.80065l3.837417-11.797827-10.047303-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418974zM177.09292 31.510075l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                                <g className="tp-star">
                                                    <path
                                                        className="tp-star__canvas"
                                                        fill="#dcdce6"
                                                        d="M205.064416 46.330002h46.375587V0h-46.375587z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__canvas--half"
                                                        fill="#dcdce6"
                                                        d="M205.064416 46.330002h23.187793V0h-23.187793z"
                                                    ></path>
                                                    <path
                                                        className="tp-star__shape"
                                                        d="M244.597022 19.711433l-26.3029 19.089218 3.837419-11.797827-10.047304-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418975zm-16.255436 11.798642l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                                                        fill="#FFF"
                                                    ></path>
                                                </g>
                                            </svg>
                                        </div>

                                        <b className="review-header">Quick and easy</b>
                                        <div className="review-text">Awesome! User friendly would recommend to anyone</div>
                                        <div className="review-name">Nicklaus</div>
                                        <div className="review-date">3 hours ago</div>
                                    </div>
                                </Slider>

                                <div className="swiper-button-next"></div>
                                <div className="swiper-button-prev"></div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </section >
    );
};

export default ReviewSlider;
